
    import './styles.scoped.css';
    export default {
  "dimmed": "awsui_dimmed_10ipo_1fn0z_97",
  "marker": "awsui_marker_10ipo_1fn0z_148",
  "marker--line": "awsui_marker--line_10ipo_1fn0z_191",
  "marker--rectangle": "awsui_marker--rectangle_10ipo_1fn0z_195",
  "marker--hollow-rectangle": "awsui_marker--hollow-rectangle_10ipo_1fn0z_202",
  "marker--dashed": "awsui_marker--dashed_10ipo_1fn0z_218",
  "root": "awsui_root_10ipo_1fn0z_241",
  "value": "awsui_value_10ipo_1fn0z_276",
  "expandable": "awsui_expandable_10ipo_1fn0z_280",
  "list-item": "awsui_list-item_10ipo_1fn0z_284",
  "inner-list-item": "awsui_inner-list-item_10ipo_1fn0z_285",
  "key-value-pair": "awsui_key-value-pair_10ipo_1fn0z_290",
  "expandable-section": "awsui_expandable-section_10ipo_1fn0z_291",
  "key": "awsui_key_10ipo_1fn0z_290",
  "sub-items": "awsui_sub-items_10ipo_1fn0z_304",
  "list": "awsui_list_10ipo_1fn0z_284",
  "compact": "awsui_compact_10ipo_1fn0z_330",
  "with-sub-items": "awsui_with-sub-items_10ipo_1fn0z_335",
  "full-width": "awsui_full-width_10ipo_1fn0z_340",
  "announced": "awsui_announced_10ipo_1fn0z_344"
};
  